export default {
    namespaced: true,
    state: {
        user: {},
    },
    getters: {
        user: state => state.user
    },
    mutations: {
        SET_AUTH_USER: (state, data) => {
            state.user = data;
        },
        UNSET_AUTH_USER: (state) => state.user = []
    },
    actions: {
        FETCH_USER_PROFILE: ({commit}) => new Promise((resolve, reject) => {
            axios.get('/api/profile')
                .then((res) => {
                    commit('SET_AUTH_USER', res.data.user)
                    resolve()
                })
                .catch((error) => {
                    if (error.response.status === 401) {
                        localStorage.removeItem('logged')
                    }
                    reject()
                })
        }),
        REMOVE_USER_PROFILE: ({commit}) => {
            commit('UNSET_AUTH_USER')
        }
    }
}
